module.exports = __webpack_public_path__ + "img/spear.09486ac8.svg";